import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
/* ======== Components ========= */
import { FAB, type FABProps } from "../FAB";

type Props = {
	bottom?: number;
} & FABProps;
const BottomFab = ({ onPress, icon, label, bottom, ...rest }: Props) => {
	const theme = useAppTheme();

	const insets = useSafeAreaInsets();

	return (
		<Box
			style={{
				position: "absolute",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				right: 16,
				bottom: bottom || insets.bottom + (Platform.OS === "ios" ? 0 : 16),
			}}
		>
			<FAB
				onPress={onPress}
				style={{
					maxWidth: "100%",
					backgroundColor: theme.colors.primary,
				}}
				color={theme.colors.onPrimary}
				icon={icon}
				label={label!}
				variant="primary"
				{...rest}
			/>
		</Box>
	);
};

export default BottomFab;
